import { Component, Inject, Input, QueryList, ViewChildren, forwardRef } from '@angular/core';
import { DialogParams, DialogService } from '../../../../core/services/dialog.service';
import { TenantService } from '../../../../core/services/tenant.service';
import { Tenant } from '../../../../data/models';
import { RepoAuthService } from '../../../../data/repositories/repo-auth.service';
import { SharedDataService } from '../../../../data/services/shared-data.service';

@Component({
    selector: 'app-sidebar2-subpanel-tenant',
    templateUrl: './sidebar2-subpanel-tenant.component.html',
    standalone: false,
})
export class Sidebar2SubpanelTenantComponent {
    // @ts-ignore TS2564
    @ViewChildren(forwardRef(() => Sidebar2SubpanelTenantComponent)) components: QueryList<Sidebar2SubpanelTenantComponent>;
    // @ts-ignore TS2564
    @Input() tenant: Tenant;
    // @ts-ignore TS2564
    @Input() dropDownClasses: string;
    // @ts-ignore TS2564
    @Input() depth: number;
    dropdownOpen = false;

    public get ChildCount() {
        if (!this.components) {
            return 0;
        }
        // @ts-ignore TS2532
        let childCount = this.tenant && this.tenant.children.length;
        this.components.forEach((c) => {
            childCount = childCount + c.ChildCount;
        });
        return childCount;
    }

    constructor(
        @Inject(RepoAuthService) private authService: RepoAuthService,
        public sharedData: SharedDataService,
        private tenantService: TenantService,
        private dialogService: DialogService
    ) {}

    headerLink(event: Event) {
        this.tenant.expanded = !this.tenant.expanded;
        this.tenantService.setExpandedSetting(this.tenant, this.tenant.expanded);
        event.stopPropagation();
    }

    async switchTenant() {
        const params: DialogParams = {
            type: 'info',
            title: 'Switch Business',
            text: `You will now be logged into ${this.tenant.name}. Do you wish to proceed?`,
            okText: 'Switch Business',
            cancelText: 'Not now',
        };

        try {
            await this.dialogService.show(params);
            await this.authService.getAuth0TokenForNewTenant(this.tenant.tenantId);
            window.location.reload();
        } catch {}
    }
}
